import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { formattedLongDate } from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import {
  fetchFreeDietPackagesData,
  fetchPaidDietPackagesData,
} from "../../../redux/reducers/apiSlice";
import { selectToken } from "../../auth/auth.selector";
import AssignDiet from "./assign-diet/AssignDiet";
import ViewGoalDiets from "../dietPackage/ViewGoalDiets";

const DietPlansTab = ({ sendableDPQPs, callFunction }) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const { loading, freeDietPackages, paidDietPackages } = useSelector(
    (state) => state.api
  );
  const iniDPdata = {
    freeData: [],
    paidData: [],
    isPageFree: 0,
    isPagePaid: 0,
    paginationFree: [],
    paginationPaid: [],
  };
  const [dietPackages, setDietPackages] = useState(iniDPdata);
  const {
    isPageFree,
    isPagePaid,
    paginationFree,
    paginationPaid,
    freeData,
    paidData,
  } = dietPackages || {};

  const initialClickValues = {
    name: "",
    dietAssignModal: false,
    dietPackageID: "",
    rowData: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const onClickValues = (e, value, row) => {
    e.preventDefault();

    setClickValues((prevs) => ({
      ...prevs,
      dietAssignModal: true,
      dietPackageID: value,
      rowData: row,
    }));
  };

  const onCloseModal = () => {
    setClickValues(initialClickValues);
  };

  useEffect(() => {
    dispatch(
      fetchFreeDietPackagesData({
        pageNo: isPageFree + 1,
        limit: 10,
        queryParameters: "is_paid=0&status=active" + sendableDPQPs,
        token: token,
      })
    );
  }, [isPageFree, sendableDPQPs]);

  useEffect(() => {
    dispatch(
      fetchPaidDietPackagesData({
        pageNo: isPagePaid + 1,
        limit: 10,
        queryParameters: "is_paid=1&status=active" + sendableDPQPs,
        token: token,
      })
    );
  }, [isPagePaid, sendableDPQPs]);

  useEffect(() => {
    if (freeDietPackages?.status && freeDietPackages?.data?.length > 0) {
      const { data, pagination } = freeDietPackages || {};

      setDietPackages((prevs) => ({
        ...prevs,
        freeData: data,
        paginationFree: pagination,
      }));
    } else {
      setDietPackages((prevs) => ({
        ...prevs,
        freeData: [],
        paginationFree: [],
      }));
    }
  }, [freeDietPackages]);

  useEffect(() => {
    if (paidDietPackages?.status && paidDietPackages?.data?.length > 0) {
      const { data, pagination } = paidDietPackages || {};

      setDietPackages((prevs) => ({
        ...prevs,
        paidData: data,
        paginationPaid: pagination,
      }));
    } else {
      setDietPackages((prevs) => ({
        ...prevs,
        paidData: [],
        paginationPaid: [],
      }));
    }
  }, [paidDietPackages]);

  const dietPackageCols = [
    {
      dataField: "name",
      text: "name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data bold minWidth150">{row?.name || "NA"}</span>
        );
      },
    },
    {
      dataField: "diet_cat_type",
      text: "Diet Category",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.diet_cat_type || "NA"}</span>;
      },
    },
    {
      dataField: "type1_name",
      text: "Diet Type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.type1_name || "NA"}</span>;
      },
    },
    {
      dataField: "type2_name",
      text: "Body Preference",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.type2_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.duration || "0"} Day(S)</span>;
      },
    },
    {
      dataField: "is_paid",
      text: "Free/Paid",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.is_paid === 1 ? "Paid" : row?.is_paid === 0 ? "Free" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "user name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.diet_cat_type === "custom" ? row?.user_name : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "min_cal",
      text: "Calorie range",
      formatter: (cell, row) => (
        <div className="multi-tb-data-range minWidth90">
          <span className="tb-data">{row?.min_cal || "0"}</span> -{" "}
          <span className="tb-data">{row?.max_cal || "0"}</span>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth90">
            {row?.date_added ? formattedLongDate(+row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={(e) =>
              setClickValues((prevs) => ({
                ...prevs,
                detailsModal: true,
                mealDetails: row?.goal_diet,
                rowData: row,
              }))
            }
            style={{
              border:
                row?.goal_diet?.length > 0
                  ? "1px solid #bc0909"
                  : "1px solid #9C9C9C",
              color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              borderRadius: "12px",
              cursor: row?.goal_diet?.length > 0 ? "pointer" : "not-allowed",
            }}
            disabled={row?.goal_diet?.length === 0}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrows-angle-expand"
              viewBox="0 0 16 16"
              style={{
                color: row?.goal_diet?.length > 0 ? "#bc0909" : "#9C9C9C",
              }}
            >
              <path
                fillRule="evenodd"
                d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
              />
            </svg>
          </button>
          <button
            className="actionBtn icon text-btn"
            onClick={(e) => onClickValues(e, row?.uid, row)}
          >
            Assign Diet
          </button>
        </div>
      ),
    },
  ];

  const goalDietsCols = [
    {
      dataField: "day_no",
      text: "Day",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.day_no || "NA"}</span>;
      },
    },
    {
      dataField: "diet_time_name",
      text: "Diet Time",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.diet_time_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "meals",
      text: "Meals",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.meal_name || "NA"}</span>;
      },
    },
    {
      dataField: "quantities",
      text: "Quantities",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.quantity || 0}</span>;
      },
    },
    {
      dataField: "total_cal",
      text: "Total Calorie",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.total_cal || "0"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate(+row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.dietAssignModal}
        onRequestClose={onCloseModal}
        contentLabel="Assign Diet Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <AssignDiet
            onClose={onCloseModal}
            rowData={clickValues.rowData}
            callFunction={callFunction}
          />
        </div>
      </Modal>

      <Modal
        isOpen={clickValues.detailsModal}
        onRequestClose={() => {
          setClickValues((prevs) => ({
            ...prevs,
            detailsModal: false,
            mealDetails: [],
          }));
        }}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose
            title="Diet Details (View Only)"
            onClose={() =>
              setClickValues((prevs) => ({
                ...prevs,
                detailsModal: false,
                mealDetails: [],
              }))
            }
          />

          <div className="fullWidthFlexCenter">
            <ViewGoalDiets rowData={clickValues.rowData} />
          </div>

          {/* <div className="fullWidthFlexCenter">
            <div className="customTableContainer">
              <PayoutsTable
                dataValues={clickValues.mealDetails}
                columnsValues={goalDietsCols}
              />
            </div>
          </div> */}
        </div>
      </Modal>

      <div className="dietTabsContainer mt30">
        <Tabs>
          <TabList>
            <Tab>Free</Tab>
            <Tab>Paid</Tab>
          </TabList>

          <TabPanel>
            <div className="fullWidthFlexCenter overflowAuto separatedTable  mt30">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={freeData}
                  tableColumns={dietPackageCols}
                  tablePagination={paginationFree}
                  isPage={isPageFree}
                  setIsPage={(value) =>
                    setDietPackages((prevData) => ({
                      ...prevData,
                      isPageFree: value,
                    }))
                  }
                />
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="fullWidthFlexCenter overflowAuto separatedTable  mt30">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={paidData}
                  tableColumns={dietPackageCols}
                  tablePagination={paginationPaid}
                  isPage={isPagePaid}
                  setIsPage={(value) =>
                    setDietPackages((prevData) => ({
                      ...prevData,
                      isPagePaid: value,
                    }))
                  }
                />
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default DietPlansTab;
